module.exports = __webpack_public_path__ + "img/qr@2x.e91e3cc7.png";